import { KeycloakManagerEnvService } from '../env/keycloak-manager-env.service';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeycloakManagerRouting extends BaseRouting {
  static configPath = ':configId';
  static APP_ROUTE = 'keycloak-manager';

  static userPath = 'user';
  static userDefaultPath = '';

  static groupPath = 'group';
  static groupDefaultPath = '';
  static groupDetailPath = 'single/:id';

  static rolePath = 'role';
  static roleDefaultPath = '';
  static roleDetailPath = ':name';

  static clientPath = 'client';
  static clientDefaultPath = '';
  static clientDetailPath = ':id';

  static realmPath = 'realm';
  static realmDefaultPath = '';

  private _userDefault: string[] = [KeycloakManagerRouting.userPath];
  private _groupDefault: string[] = [KeycloakManagerRouting.groupPath];
  private _groupSingle: string[] = [KeycloakManagerRouting.groupPath, KeycloakManagerRouting.groupDetailPath];
  private _roleDefault: string[] = [KeycloakManagerRouting.rolePath];
  private _roleSingle: string[] = [KeycloakManagerRouting.rolePath, KeycloakManagerRouting.roleDetailPath];
  private _clientDefault: string[] = [KeycloakManagerRouting.clientPath];
  private _clientSingle: string[] = [KeycloakManagerRouting.clientPath, KeycloakManagerRouting.clientDetailPath];
  private _realmDefault: string[] = [KeycloakManagerRouting.realmPath];
  private _realmSingle: string[] = [KeycloakManagerRouting.realmPath, KeycloakManagerRouting.realmDefaultPath];

  constructor(keycloakManagerEnv: KeycloakManagerEnvService) {
    super(['/' + KeycloakManagerRouting.APP_ROUTE, KeycloakManagerRouting.configPath], keycloakManagerEnv);
  }

  public userDefault(configId: string = this.getConfigId()): void {
    this.nav(this._userDefault, {
      configId
    });
  }

  public userDefaultAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._userDefault, {
      configId
    });
  }

  public userDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._userDefault, {
      configId
    });
  }

  public groupDefault(configId: string = this.getConfigId()): void {
    this.nav(this._groupDefault, {
      configId
    });
  }

  public groupDefaultAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._groupDefault, {
      configId
    });
  }

  public groupDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._groupDefault, {
      configId
    });
  }

  public groupSingle(id: string, configId: string = this.getConfigId()): void {
    this.nav(this._groupSingle, {
      configId,
      id
    });
  }

  public groupSingleAbsUrl(id: string, configId: string = this.getConfigId()): string {
    return this.absUrl(this._groupSingle, {
      configId,
      id
    });
  }

  public groupSingleRouteUrl(id: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._groupSingle, {
      configId,
      id
    });
  }

  public roleDefault(configId: string = this.getConfigId()): void {
    this.nav(this._roleDefault, {
      configId
    });
  }

  public roleSingle(name: string, configId: string = this.getConfigId()): void {
    this.nav(this._roleSingle, {
      configId,
      name
    });
  }

  public roleDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._roleDefault, {
      configId
    });
  }

  public clientDefault(configId: string = this.getConfigId()): void {
    this.nav(this._clientDefault, {
      configId
    });
  }

  public clientDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._clientDefault, {
      configId
    });
  }

  public clientSingle(id: string, configId: string = this.getConfigId()): void {
    this.nav(this._clientSingle, {
      configId,
      id
    });
  }

  public realmDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._realmDefault, {
      configId
    });
  }
}
